'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _dom = require('../common/dom.js');

var _dom2 = _interopRequireDefault(_dom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Vendor
var init = exports.init = function init() {
  bindUIActions();
};

var bindUIActions = function bindUIActions() {
  (0, _jquery2.default)(document).on('click', _dom2.default.scrollElement, function (e) {
    e.preventDefault();
    var target = (0, _jquery2.default)(this).attr('data-scroll-target');

    if (target === '#') {
      return false;
    } else if (target === 'top') {
      (0, _jquery2.default)('html, body').animate({
        scrollTop: 0
      }, 750);
    } else {
      (0, _jquery2.default)('html, body').animate({
        scrollTop: (0, _jquery2.default)(target).offset().top - 80
      }, 750);
    }
  });
};